export enum PLANNING_MODULES {
  PLANNING_PLAN = 'PLANNING_PLAN',
  PLANNING_OFFSET_SEQUENCES = 'PLANNING_OFFSET_SEQUENCES',
  PLANNING_OFFSET_TIME_VS_DEPTH = 'PLANNING_OFFSET_TIME_VS_DEPTH',
  PLANNING_OFFSET_TIME_BREAKDOWN = 'PLANNING_OFFSET_TIME_BREAKDOWN',
}

export const planningPanelModules = Object.values(PLANNING_MODULES);
